import React from 'react';
import { useTranslation } from 'react-i18next';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import styles from './SizeAttributeLabel.module.scss';

export const SizeAttributeLabel = (choice: SizeChoice) => {
    const { t } = useTranslation();
    return (
        <div className={styles.default}>
            <p className={styles.label}>{t(choice.label)}</p>
            <p className={styles.subText}>
                {t(choice.options?.subText ?? '')}
            </p>
        </div>
    );
};